import React from 'react';
import { formatCurrency } from '../../../utils/formatters';
import { formatPercentage, getRemaining, getTotalContracted, getTotalPayments } from '../../../utils/budgetUtils';

const TotalsRow = ({ sortedScopes }) => {
  // Calculate total budget across all scopes
  const totalBudget = sortedScopes.reduce((sum, scope) => {
    return sum + (scope.budget || 0);
  }, 0);
  
  // Calculate total payments across all scopes
  const totalPayments = sortedScopes.reduce((sum, scope) => {
    return sum + getTotalPayments(scope);
  }, 0);
  
  // Calculate total remaining across all scopes
  const totalRemaining = sortedScopes.reduce((sum, scope) => {
    const remaining = getRemaining(scope);
    return sum + (remaining || 0);
  }, 0);
  
  // Calculate total contracted amount
  const totalContracted = sortedScopes.reduce((sum, scope) => 
    sum + getTotalContracted(scope)
  , 0);
  
  return (
    <tr className="bg-gray-50 dark:bg-gray-700 font-semibold">
      <td colSpan={2} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 dark:text-gray-100 sm:pl-6">
        Totals
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100 text-right">
        {formatCurrency(totalBudget)}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100 text-right">
        {/* Average completion percentage */}
        {formatPercentage(
          sortedScopes.length > 0 
            ? Math.round(sortedScopes.reduce((sum, scope) => sum + (scope.percentage_complete || 0), 0) / sortedScopes.length) 
            : 0
        )}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100 text-right">
        {formatCurrency(totalContracted)}
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {sortedScopes.reduce((sum, scope) => sum + scope.contracts.length, 0)} contracts
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100 text-right">
        {formatCurrency(totalPayments)}
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {sortedScopes.reduce((sum, scope) => sum + scope.payments.length, 0)} payments
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-gray-100 text-right">
        {formatCurrency(totalRemaining)}
      </td>
    </tr>
  );
};

export default TotalsRow;